// V17.299: says out loud which columns have no data behind them.
//
// Without this the board shows a wall of zeros, and a zero is a claim —
// "nobody collected today". When the source table has never been written to,
// that claim is false. The dashes in TeamBoardTable make the absence visible;
// this explains it.
//
// One note per dark source, not one combined note: the sources fail
// independently, and a leader needs to know WHICH pipeline to chase.

import type { TeamBoardSources } from '../../services/arTeamBoard';
import { useTeamBoardStrings } from '../../utils/teamBoardI18n';

interface Props {
  sources: TeamBoardSources | undefined;
  variant: 'page' | 'tv';
}

export default function UninstrumentedBanner({ sources, variant }: Props) {
  const t = useTeamBoardStrings();
  if (!sources) return null;

  const notes: string[] = [];
  if (!sources.calls_recorded_90d) notes.push(t.notRecorded.calls);
  if (!sources.collections_recorded_90d) notes.push(t.notRecorded.collections);
  if (!sources.ledger_recorded_90d) notes.push(t.notRecorded.ledger);
  if (notes.length === 0) return null;

  const tv = variant === 'tv';

  return (
    <div className={tv ? 'mb-2' : 'mb-3'}>
      {notes.map((note) => (
        <div
          key={note}
          data-testid="uninstrumented-note"
          className={`rounded border border-amber-300 bg-amber-50 text-amber-800
                      dark:border-amber-700 dark:bg-amber-950 dark:text-amber-200
                      ${tv ? 'px-4 py-2 text-lg' : 'px-3 py-2 text-xs'}
                      ${notes.length > 1 ? 'mt-1 first:mt-0' : ''}`}
        >
          {note}
        </div>
      ))}
    </div>
  );
}
